import { render, staticRenderFns } from "./VehicleIndex.vue?vue&type=template&id=216b5328&scoped=true&"
import script from "./VehicleIndex.vue?vue&type=script&lang=js&"
export * from "./VehicleIndex.vue?vue&type=script&lang=js&"
import style0 from "./VehicleIndex.vue?vue&type=style&index=0&id=216b5328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b5328",
  null
  
)

export default component.exports